import type { ComponentPropsWithoutRef } from 'react';
import { cn } from './utils';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends ComponentPropsWithoutRef<'span'> {
  size?: SpinnerSize;
  /** Accessible label announced to assistive technology. */
  label?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-3.5 w-3.5 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export function Spinner({ size = 'md', label = 'Loading', className, ...props }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent',
        sizeClasses[size],
        className,
      )}
      {...props}
    />
  );
}
